import React, {
  useEffect,
  useRef,
  useCallback
} from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import { mount, unmount } from 'redom';

import Helpers from '../../helpers';

import BaseElement from '../base';

import MemberCalendarFacade from './';

// eslint-disable-next-line import/first
import './index.scss';

function MemberCalendarFacadeWrapper(props) {

  const element = props.element;

  const memberCalendarContainerReference = useRef(null);
  const memberCalendarReference = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memberCalendarChangeCallback = useCallback(handleMemberCalendarFacadeChange, []);
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    return initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initializeMemberCalendarFacade() {

    const memberCalendar = new MemberCalendarFacade({
      ...(element.options || {}),
      onChange: memberCalendarChangeCallback
    });

    memberCalendarReference.current = memberCalendar;

    mount(memberCalendarContainerReference.current, memberCalendar);

    return memberCalendar;

  }

  function initialize() {

    const memberCalendarContainer = memberCalendarContainerReference.current;

    const memberCalendar = initializeMemberCalendarFacade();

    return function onUnload() {

      unmount(memberCalendarContainer, memberCalendar);

    };

  }

  function handleMemberCalendarFacadeChange(options) {

    Helpers.setAttributes(editor, {
      options: {
        ...(element.options || {}),
        ...options
      }
    }, elementPath);

  }

  function renderMemberCalendarFacade() {

    const mainAttributes = {
      ...props.attributes,
      className: 'member-calendar-element',
      contentEditable: false
    };

    const containerAttributes = {
      className: 'member-calendar-element-container',
      ref: memberCalendarContainerReference,
      contentEditable: false,
      style: {
        userselect: 'none'
      }
    };

    return <div {...mainAttributes}>
      <div {...containerAttributes}>
      </div>
      {props.children}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'member-calendar-wrapper'
    };

    return <BaseElement {...baseElementProperties}>
      {renderMemberCalendarFacade()}
    </BaseElement>;

  }

  return renderMain();

}

export default MemberCalendarFacadeWrapper;